import { createContext } from "react";

export interface creditsInfoT {
  creditsUsed: number;
  creditsAvailable: number;
}

export const CreditsContext = createContext(null);
